module.exports = __webpack_public_path__ + "static/media/daukhi_banner.303ccd79.webp";